import moment from 'moment';
import { Row } from 'react-table';
import { CountryFlag } from 'CountryFlag/CountryFlag';

import styles from './VesselsCatalogModal.module.scss';
import { Link } from 'react-router-dom';
import { useFormatMoment } from 'app/hooks/useFormatMoment';
import i18n from 'i18next';
import { WithinDistanceTargetCatalogEntryInfo } from 'ais-facade-api/api';
import { Icon, VesselIcon } from 'app/components';

export const NearbyShipsColumns = [
  {
    Header: <Icon name="s-ais" size="20px" color="#fff" />,
    accessor: 'type',
    Cell: ({ row: { original: vessel } }: { row: Row<WithinDistanceTargetCatalogEntryInfo> }) => {
      return (
        <div className={styles.center_cell}>
          <VesselIcon vessel={vessel.target} size="20px" />
        </div>
      );
    },
    width: 34,
    minWidth: 34,
    maxWidth: 34,
  },
  {
    Header: 'MMSI',
    accessor: 'mmsi',
    cellClassName: `${styles.link}`,
    Cell: ({ row: { original: vessel } }: { row: Row<WithinDistanceTargetCatalogEntryInfo> }) =>
      typeof vessel?.target?.mmsi === 'number' ? (
        <Link to={`/vessels/${vessel.target.mmsi}`} target="_blank" className={styles.link}>
          {vessel.target.mmsi}
        </Link>
      ) : (
        <>&mdash;</>
      ),
    canSort: true,
    sortBy: 'MMSI',
  },
  {
    Header: 'Name',
    accessor: 'staticData?.name',
    Cell: ({ row: { original: vessel } }: { row: Row<WithinDistanceTargetCatalogEntryInfo> }) => (
      <>
        {typeof vessel?.target?.registryData?.name === 'string' ? (
          vessel.target.registryData.name
        ) : typeof vessel?.target?.staticData?.name === 'string' ? (
          vessel.target.staticData?.name
        ) : (
          <>&mdash;</>
        )}
      </>
    ),
    canSort: true,
    sortBy: 'NAME',
  },
  {
    Header: 'IMO',
    accessor: 'staticData?.imo',
    Cell: ({ row: { original: vessel } }: { row: Row<WithinDistanceTargetCatalogEntryInfo> }) => (
      <>
        {typeof vessel?.target?.registryData?.imo === 'number' ? (
          vessel.target.registryData.imo
        ) : typeof vessel?.target?.staticData?.imo === 'number' ? (
          vessel.target.staticData.imo
        ) : (
          <>&mdash;</>
        )}
      </>
    ),
    canSort: true,
    sortBy: 'IMO',
  },
  {
    Header: 'CallSign',
    Cell: ({ row: { original: vessel } }: { row: Row<WithinDistanceTargetCatalogEntryInfo> }) => (
      <>
        {typeof vessel?.target?.registryData?.callSign === 'string' ? (
          vessel.target.registryData.callSign
        ) : typeof vessel?.target?.staticData?.callSign === 'string' ? (
          vessel.target.staticData.callSign
        ) : (
          <>&mdash;</>
        )}
      </>
    ),
  },
  {
    Header: 'Flag',
    Cell: ({ row: { original: vessel } }: { row: Row<WithinDistanceTargetCatalogEntryInfo> }) => (
      <>
        {vessel?.target?.meta?.countryName ? (
          <>
            {vessel.target.meta.countryCode && <CountryFlag countryCode={vessel.target.meta.countryCode.toLocaleLowerCase()} />}
            {vessel.target.meta.countryName} ({vessel.target.meta.countryCode})
          </>
        ) : (
          <>&mdash;</>
        )}
      </>
    ),
  },
  {
    Header: 'Type',
    Cell: ({ row: { original: vessel } }: { row: Row<WithinDistanceTargetCatalogEntryInfo> }) => (
      <>{vessel?.target?.meta?.typeGroup ? vessel.target.meta.typeGroup : <>&mdash;</>}</>
    ),
  },
  {
    Header: 'NavStatus',
    Cell: ({ row: { original: vessel } }: { row: Row<WithinDistanceTargetCatalogEntryInfo> }) => (
      <>{typeof vessel?.target?.meta?.status === 'string' ? vessel.target.meta.status : <>&mdash;</>}</>
    ),
  },
  {
    Header: 'Destination',
    Cell: ({ row: { original: vessel } }: { row: Row<WithinDistanceTargetCatalogEntryInfo> }) => (
      <>{vessel?.target?.voyage?.destination ? vessel.target.voyage.destination : <>&mdash;</>}</>
    ),
  },
  {
    Header: 'Course',
    Cell: ({ row: { original: vessel } }: { row: Row<WithinDistanceTargetCatalogEntryInfo> }) => (
      <>{typeof vessel?.target?.position?.cog === 'number' ? <>{vessel.target.position.cog}&deg;</> : <>&mdash;</>}</>
    ),
  },
  {
    Header: 'Speed',
    Cell: ({ row: { original: vessel } }: { row: Row<WithinDistanceTargetCatalogEntryInfo> }) => (
      <>
        {typeof vessel?.target?.position?.sog === 'number' ? (
          vessel.target.position.sog.toFixed(2) + ` ${i18n.t('VesselSpeedUnit')}`
        ) : (
          <>&mdash;</>
        )}
      </>
    ),
  },
  {
    Header: 'Distance',
    Cell: ({ row: { original: vessel } }: { row: Row<WithinDistanceTargetCatalogEntryInfo> }) => (
      <>
        <div> {typeof vessel?.distanceKm === 'number' ? `${vessel.distanceKm.toFixed(1)} ${i18n.t('Km')}` : <>&mdash;</>}</div>
        <div>{typeof vessel?.distanceNmi === 'number' ? `${vessel.distanceNmi.toFixed(1)} NM` : <>&mdash;</>}</div>
      </>
    ),
    canSort: true,
    sortBy: 'DISTANCE',
  },
  {
    Header: 'DataObtained',
    Cell: ({ row: { original: vessel } }: { row: Row<WithinDistanceTargetCatalogEntryInfo> }) => {
      const formatMoment = useFormatMoment();
      return <>{vessel?.target?.t ? formatMoment(moment(vessel.target.t)) : <>&mdash;</>}</>;
    },
    canSort: true,
    sortBy: 'RECEIVED_DATE',
  },
];
